import createAdaptiveCardsConfig from 'botframework-webchat/lib/adaptiveCards/Styles/adaptiveCardHostConfig';
import { StyleOptions as WebChatStyleOptions } from 'botframework-webchat';
import { StyleOptions as BFFStyleOptions } from '@sa/bff-webchat-ui';

const DEFAULT_ACCENT = '#0076D6';

export function buildFontFamily(fonts: string[]) {
  return fonts
    .map(function (font) {
      // tslint:disable-next-line:quotemark
      return "'".concat(font, "'");
    })
    .join(', ');
}

// For more info about how adaptive cards host config format and how it fits into botframework:
// https://docs.microsoft.com/en-us/adaptive-cards/rendering-cards/host-config
// https://github.com/microsoft/BotFramework-WebChat/issues/2034#issuecomment-501818238
// https://bisser.io/bot-framework-v4-webchat-styling-options/
// These properties follow that format
const primaryFont = buildFontFamily([
  '-apple-system',
  'BlinkMacSystemFont',
  'Open Sans',
  'Seqoe UI',
  'Roboto',
  'Helvetica New',
  'Arial',
  'Noto Sans',
  'sans-serif',
  'Apple Color Emoji',
  'Segoe UI Symbol',
  'Noto Color Emoji'
]);
const fontSizes = {
  small: 12,
  default: 16,
  medium: 18,
  large: 20,
  extraLarge: 22
};
const fontWeights = {
  lighter: 200,
  default: 400,
  bolder: 600
};

export const bffStyleOptions: BFFStyleOptions = {
  loadingColor: DEFAULT_ACCENT,
  primaryFont
};

export const webChatStyleOptions: WebChatStyleOptions = {
  accent: DEFAULT_ACCENT,
  backgroundColor: '#E4E4E4',

  autoScrollSnapOnPage: true,

  // Bot Bubble
  bubbleBackground: '#FFFFFF',
  bubbleTextColor: '#000000',
  bubbleBorderRadius: 8,
  bubbleNubSize: 11,
  bubbleNubOffset: 6,

  // User Bubble
  bubbleFromUserBackground: DEFAULT_ACCENT,
  bubbleFromUserTextColor: '#FFFFFF',
  bubbleFromUserBorderRadius: 8,
  bubbleFromUserNubSize: 11,
  bubbleFromUserNubOffset: 6,
  // Suggested actions
  suggestedActionBorderColor: '#E0E0E0', // defaults to accent
  suggestedActionBorderRadius: 6,
  suggestedActionBorderStyle: 'solid',
  suggestedActionBorderWidth: 0,
  suggestedActionBackgroundColor: '#E0E0E0',
  suggestedActionTextColor: 'white',
  //suggestedActionLayout: 'stacked', // either "carousel" or "stacked"
  // Other settings
  primaryFont,
  richCardWrapTitle: true,
  hideUploadButton: true, // Bot does not accept files
  //timestampFormat: 'absolute',
  timestampColor: '#666666'
};

export const adaptiveCardsHostConfig: Record<string, any> = createAdaptiveCardsConfig(webChatStyleOptions);
adaptiveCardsHostConfig.fontFamily = primaryFont;
adaptiveCardsHostConfig.fontSizes = fontSizes;
adaptiveCardsHostConfig.fontWeights = fontWeights;

//text colour
adaptiveCardsHostConfig.containerStyles.default.foregroundColors.default.default = webChatStyleOptions.bubbleTextColor;
